import Analytics from "analytics";
import segmentPlugin from "@analytics/segment";

export const analytics = Analytics({
  app: "awesome-app",
  plugins: [
    segmentPlugin({
      writeKey: process.env.REACT_APP_SEFMENT_WRITE_KEY,
    }),
  ],
});
